import { Bike, BusFront, CarFront, CarTaxiFront, Footprints } from "lucide-react";
import { travelModes, transportLabels, transportNotes, type TravelMode } from "./lib/transport";

function Motorcycle({size = 20}: {size?: number}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="5" cy="17" r="3.5"/><circle cx="19" cy="17" r="3.5"/><path d="m5 17 5-7h5l4 7M9 17h4l3-5M3 10h6l2 3M14 5h3l2 6M12 8h3"/></svg>;
}
function Scooter({size = 20}: {size?: number}) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="4" cy="19" r="2.5"/><circle cx="20" cy="19" r="2.5"/><path d="M4 16h9l5-12h-4M18 4l2 12M3 14v2"/></svg>;
}
const icons = { car: CarFront, motorcycle: Motorcycle, bicycle: Bike, scooter: Scooter, taxi: CarTaxiFront, bus: BusFront, walking: Footprints };
export function TransportPicker({ value, onChange }: { value: TravelMode; onChange: (mode: TravelMode) => void }) {
  return <div className="transport-picker">
    <div className="transport-modes" role="group" aria-label="סוג תחבורה">
      {travelModes.map(mode => { const Icon = icons[mode]; return <button key={mode} type="button"
        aria-pressed={value === mode} onClick={() => onChange(mode)}><Icon size={20}/><span>{transportLabels[mode]}</span></button>; })}
    </div>
    <p className="transport-note" role="status">{transportNotes[value]}</p>
  </div>;
}
